import React from "react"
import styled from "styled-components"

export default function OrderConfirmNotice() {
  return (
    <NoticeBlock>
      <NoticeParagraph>{`배송 완료 후, 7일 이내 인증 시작버튼을 누르지 않을 시,\n환급이 불가합니다.`}</NoticeParagraph>
    </NoticeBlock>
  )
}

const NoticeBlock = styled.div`
  background-color: #f7f7f7;
  display: flex;
  align-items: center;
  padding-left: calc(100vw * (33 / 375));
  padding-right: calc(100vw * (15 / 375));
  padding-top: calc(100vw * (16 / 375));
  padding-bottom: calc(100vw * (16 / 375));
  margin-bottom: calc(100vw * (22 / 375));
  border-radius: calc(100vw * (5 / 375));
`

const NoticeParagraph = styled.p`
  position: relative;
  font-size: calc(100vw * (12 / 375));
  font-weight: 500;
  line-height: calc(100vw * (16.92 / 375));
  white-space: pre-wrap;
  color: #7f7f7f;

  &::before {
    content: "✔️";
    position: absolute;
    top: 0;
    left: calc(100vw * (-16 / 375));
    font-size: calc(100vw * (9 / 375));
  }
`
